
import state from './../../zviz2/zviz/state';
import {default as Group, Controller as GroupController} from './../../zviz2/zviz/components/group';
import Rectangle from './../../zviz2/zviz/components/rectangle';
import {extend} from './../../zviz2/zviz/functions';

import Countries from './countries';

//import {LifeCycle} from './../zviz2/zviz/cycle';

import config from './../../config';

class Controller extends GroupController{

    constructor(parent, blueprint={}){

        super(parent, blueprint);        
        
    }

    

    getCountryHighlight(){
        return false;
    }

    // getGeoData(value, dimension){
    //     let ctrl = this.getControllerByUid('countries');

    //     if(ctrl == null){
    //         console.log('controller not found');
    //         return null;
    //     }
    //     return ctrl.getGeoData(value, dimension);
    // }

    getFades(){
        
        let d = config.display.fadeWidth;
        let height = this.data.height;
        let width = this.data.width;

        let fades = [
            {x: 0, y: 0, h: d, w: width},
            {x: width-d, y: 0, h: height, w: d},
            {x: 0, y: height-d, h: d, w: width},
            {x: 0, y: 0, h: height, w: d},
        ];

        let result = [];
        let i = 1;
        for(let fade of fades){

            result.push(extend({
                properties: {
                    attributes: {
                        'x': fade.x,
                        'y': fade.y,
                        'width': fade.w,
                        'height': fade.h,
                    },
                    style: {
                        'fill': 'url(#mapFade'+i+')',
                    }
                }
            }, Rectangle));
            i++;

        }

        return result;
    }

} 


let Blueprint = extend({
    type: Controller,
    properties: {
        attributes: {
            'transform': 'translate(0,' + config.display.mapOffset.top + ')',
            'clip-path': 'url(#mapClipPath)'
        },
        style: {
            'clip-path': 'url(#mapClipPath)'
        },
        data: {
            width: 0,
            height: 0,
            bbox: null
        }
    },
    children: [
        extend({
            uid: 'countries',
            properties: {
                data: {
                    // (ctrl) => ( ctrl.parent.parent.getCountryHighlight() ),
                    bbox : (ctrl) =>  (ctrl.parent.data.bbox)
                }
            }
        }, Countries),

        (ctrl) => ( ctrl.getFades() )
    ]
}, Group)


export default Blueprint;
export {Controller, Blueprint};

